import React from "react";

import makeStyles from "@mui/styles/makeStyles";
import ListItem from "@mui/material/ListItem";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";

import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SecureIcon from "@mui/icons-material/Lock";
import OpenIcon from "@mui/icons-material/LockOpen";

import { ListItemIcon } from "@mui/material";
import { grey } from "@mui/material/colors";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    fontSize: "1.25rem",
    borderBottom: "solid",
    borderBottomColor: grey[200],
  },

  contentTitle: {
    fontSize: "1.75rem",
    fontWeight: "bold",
  },

  contentContainer: {
    width: "80%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
  },

  mainDetail: {
    "& div": {
      width: "100%",
      padding: "0.5rem 0 0 0",
      margin: "0.1rem 0",
      whiteSpace: "normal",

      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  trackingDetail: {
    "& div": {
      width: "100%",
      padding: "0.5rem 0 0 0",
      margin: "0.1rem 0",
      whiteSpace: "normal",
      fontSize: "1.6rem",

      "& label": {
        fontWeight: "bold",
        paddingRight: "0.5em",
      },
    },
  },

  actionContainer: {
    "& button": {
      margin: "10px 0",
    },
  },
}));

const PapiServerListItem = props => {
  const { server, selected, onEditClick, onDeleteClick } = props;
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      classes={{ root: classes.itemContent }}
      key={server.patronApiServerId}
    >
      <ListItemIcon>
        {server.secure ? (
          <SecureIcon color={"primary"} />
        ) : (
          <OpenIcon color={"error"} />
        )}
      </ListItemIcon>
      <ListItemText
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>
              {server.patronApiServerId}
            </div>
          </React.Fragment>
        }
        secondary={
          <React.Fragment>
            <div className={classes.contentContainer}>
              <div className={classes.mainDetail}>
                <div>
                  <label>Hostname:</label>
                  {server.hostname}
                </div>
                <div>
                  <label>Port:</label>
                  {server.port}
                </div>
              </div>
              <div className={classes.trackingDetail}>
                <div>
                  <div>
                    <label>Created By:</label>
                    {server.createdUser.username}
                  </div>
                  <div>
                    <label>Date Created:</label>
                    {server.dateCreated}
                  </div>
                </div>
                <div>
                  <div>
                    <label>Updated By:</label>
                    {server.updatedUser.username}
                  </div>
                  <div>
                    <label>Date Updated:</label>
                    {server.dateUpdated}
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.actionContainer }}>
        <IconButton
          autoFocus={selected}
          edge="end"
          aria-label="edit"
          onClick={() => onEditClick(server)}
          size="large"
        >
          <EditIcon />
        </IconButton>
        <IconButton
          edge="end"
          aria-label="delete"
          onClick={() => onDeleteClick(server)}
          size="large"
        >
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default PapiServerListItem;
